"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateWeeks = exports.weekdays = void 0;
exports.weekdays = [1, 2, 3, 4, 5, 6, 7];

function generateWeeks(monthDate) {
  var weekDate = new Date(monthDate);
  weekDate.setDate(1);
  var weeks = [];
  var rowsCount = 6;

  do {
    weeks.push(generateDaysInWeek(weekDate));
    weekDate.setDate(weekDate.getDate() + 7);
    rowsCount--;
  } while (rowsCount);

  return weeks;
}

exports.generateWeeks = generateWeeks;

function generateDaysInWeek(weekDate) {
  weekDate = new Date(weekDate);
  return exports.weekdays.map(function (day) {
    return getDayOfWeek(weekDate, day);
  });
}

function getDayOfWeek(date, k) {
  date = new Date(date);
  var day = date.getDay();
  var diff = date.getDate() - day + (day === 0 ? k - exports.weekdays.length : k);
  return new Date(date.setDate(diff));
}